'use strict';
import {Observable} from 'rxjs/Observable';
import {getOrganization} from '../../app/model/reducers/state';
import {getDomainLink, getId, getLink} from '../../core-utilities/domain/ReduxUtils';


module.exports = [
  '$modal',
  '$scope',
  '$filter',
  '$miscUtils',
  '$ngRedux',
  '$toast',
  '$exceptionHandler',
  'OrganizationDomain',
  'TeamDomain',
  'TeamsEditFilterMixin',
  'team',
  'teamType',
  TeamsEditDialogController];

function TeamsEditDialogController(
  $modal,
  $scope,
  $filter,
  $miscUtils,
  $ngRedux,
  $toast,
  $exceptionHandler,
  OrganizationDomain,
  TeamDomain,
  TeamsEditFilterMixin,
  team,
  teamType,
) {
  const vm = $scope.teamsEdit = this;
  const filterService = TeamsEditFilterMixin(vm, $scope);
  const selectProfileObservable = $scope.$createObservableFunction('toggleSelect');

  vm.save = $miscUtils.blockPromise(save);
  vm.cancel = $miscUtils.blockPromise(cancel);

  let existingTeam = !!team;
  vm.newTeam = !team;
  if (!team) {
    team = TeamDomain.$factory.create();
    team.type = teamType;
  }

  vm.team = team;
  vm.expectedMembersList = [];
  vm.selectedProfiles = {};
  vm.expectedMembers = {};
  vm.profilesInProgress = {};
  vm.profilesWithErrors = {};
  vm.moreCount = 0;

  $scope.$evalAsync(init);

  function init() {
    $ngRedux.state$
      .map(getOrganization)
      .distinctUntilChanged(null, organization => getId(organization))
      .filter(organization => !!organization)
      .take(1)
      .subscribe(organization => {
        $scope.$evalAsync(() => {
          const teamId = getId(team);
          OrganizationDomain.$getPersonnelList(getId(organization)).$bindToScope($scope, {
            property: 'personnelList',
            loaded: true,
          });
          TeamDomain.$getMembersRelations(teamId).$bindToScope($scope, {property: 'membersRelations', loaded: true});
          TeamDomain.$getMembersList(teamId).$bindToScope($scope, {property: 'membersList', loaded: true});

          const observables = filterService.initFiltering();

          watchMemberLength(observables);
        });
      });
  }


  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/

  function toggleSelect(profile) {
    if (!profile) return;
    if (vm.selectedProfiles[getId(profile)]) {
      delete vm.selectedProfiles[getId(profile)];
    } else {
      vm.selectedProfiles[getId(profile)] = true;
    }
  }

  function save() {
    team.$validate();
    if (team.$hasErrors()) {
      console.warn(team.$errors);
      return Promise.reject(team.$errors);
    } else {
      return (existingTeam ? team.update() : team.create()
        .then(newTeam => {
          vm.team = team = newTeam;
          existingTeam = true;
        }))
        .then(updateMembersInTeam)
        .then(onSaveTeamSuccess)
        .catch(onSaveTeamError); // WARNING: current callback returns a rejected promise.
    }
  }

  function cancel() {
    return $modal.cancel();
  }

  function onSaveTeamSuccess() {
    return $modal.hide();
  }

  // logs, then propogates error
  function onSaveTeamError(error) {
    console.warn('TeamManagementDialogController.save error occurred');
    $exceptionHandler(error, 'TeamManagementDialogController.save error occurred');
    return Promise.reject(error);
  }

  function updateMembersInTeam() {
    const profilesInProgress = {};
    const membersAdded = [];
    const membersRemoved = [];

    // TODO(network): verify the client is online and connected to the server

    for (const profileId in vm.selectedProfiles) {
      if (vm.selectedProfiles.hasOwnProperty(profileId) && !vm.profilesInProgress[profileId]) {
        profilesInProgress[profileId] = true;
        vm.profilesInProgress[profileId] = true;
        if ($scope.membersRelations[profileId]) {
          membersRemoved.push(profileId);
        } else {
          membersAdded.push(profileId);
        }
      }
    }

    // TODO: display progress spinner
    vm.indicateProgress = true;

    return vm.team.updateMembers(membersAdded, membersRemoved)
      .then(function () {

        // TODO(i18n): convert to message code and pluralize
        // TODO: consider reporting the list of assets in each category?
        if (membersAdded.length > 0) {
          $toast.showMessage(membersAdded.length === 1 ? 'Member Added!' : 'Member Added!', null, 'info');
        }
        if (membersRemoved.length > 0) {
          $toast.showMessage(membersRemoved.length === 1 ? 'Member Removed!' : 'Member Removed!', null, 'info');
        }
        clearSelectedProfiles(profilesInProgress);
      })
      .catch(function (error) {
        vm.indicateProgress = false;
        console.error(error);
        clearSelectedProfiles(profilesInProgress, true);
      });// TODO: show errors in view
  }

  function clearSelectedProfiles(selectedCompleted, hasError) {
    for (const profileId in selectedCompleted) {
      if (selectedCompleted.hasOwnProperty(profileId)) {
        delete vm.profilesInProgress[profileId];
        delete vm.selectedProfiles[profileId];

        if (hasError) {
          vm.profilesWithErrors[profileId] = true;
        }

        if (Object.keys(vm.profilesInProgress).length === 0) {
          // TODO: hide progress spinner
          vm.indicateProgress = false;
        }
      }
    }
  }


  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/

    // TODO: limit count based on screen size?
  const personWidth = 130;
  const baseShowCount = 2;
  vm.personWidth = personWidth;
  vm.showCount = baseShowCount;

  function watchMemberLength(filterObservables) {
    // the toggled observable is here to trigger updates.
    // we're not using the toggled ID
    const toggledProfileObservable = selectProfileObservable.map(function (it) {
      toggleSelect(it);
      return it;
    });
    const merger = Observable.combineLatest(
      filterObservables.getMembersListObservable(),
      toggledProfileObservable.startWith(null),
      buildExpectedMembers)
      .switchMap(loadDelegates);

    filterService.addSubscription(merger
      .subscribe(function (results) {
        $filter.$replaceArrayContents(vm.expectedMembersList, results);
        $scope.$evalAsync(onMembersUpdate.bind(null, results));
      })
    );
  }

  function buildExpectedMembers(members, selectedProfile) {
    // var selectedProfileId = selectedProfile && selectedProfile.$id;
    const results = [];

    for (const memberId in members) {
      if (members.hasOwnProperty(memberId)) {
        if (!vm.selectedProfiles[memberId]) {
          results.push(members[memberId]);
          vm.expectedMembers[memberId] = true;
        } else {
          delete vm.expectedMembers[memberId];
        }
      }
    }

    for (const selectedId in vm.selectedProfiles) {
      if (vm.selectedProfiles.hasOwnProperty(selectedId) && !members[selectedId]) {
        results.unshift($scope.personnelList[selectedId]);
        vm.expectedMembers[selectedId] = true;
      }
    }

    for (const expectedId in vm.expectedMembers) {
      if (vm.expectedMembers.hasOwnProperty(expectedId)
        && !vm.selectedProfiles.hasOwnProperty(expectedId)
        && !members.hasOwnProperty(expectedId)) {

        delete vm.expectedMembers[expectedId];
      }
    }

    return results;
  }

  function onMembersUpdate(membersList) {
    const length = membersList.length;
    if (length === baseShowCount + 1) {
      vm.showCount = baseShowCount + 1;
      vm.moreCount = 0;

      vm.showPlaceholder = false;
    } else if (length > baseShowCount + 1) {
      vm.showCount = baseShowCount;
      vm.moreCount = length - vm.showCount;

      vm.showPlaceholder = true;
    } else {
      vm.showCount = baseShowCount;
      vm.moreCount = 0;

      vm.showPlaceholder = false;
    }
  }

  function loadDelegates(members) {
    const promises = [];
    for (const memberId in members) {
      if (members.hasOwnProperty(memberId)) {
        promises.push(loadDelegate(members[memberId]));
      }
    }
    return Promise.all(promises);
  }

  function loadDelegate(person) {
    if (person.aliasFor) {
      return Promise.resolve(person.aliasFor);
    } else if (person && person.hasOwnProperty('aliasFor') && getLink(person, 'aliasFor').id) {
      return getDomainLink(person, 'aliasFor').then(function () {
        return person.aliasFor;
      });
    } else {
      return Promise.resolve(person);
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/personnel/controllers/TeamsEditDialogController.js